import { Language as LanguageIcon } from '@mui/icons-material';
import { Box, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import React from 'react';
import { useI18n } from '../../contexts/I18nContext';

const LanguageSwitcher = () => {
  const { locale, changeLocale, t } = useI18n();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (newLocale) => {
    changeLocale(newLocale);
    handleClose();
  };

  const languages = {
    ru: { label: 'Русский', flag: '🇷🇺' },
    en: { label: 'English', flag: '🇬🇧' },
    ky: { label: 'Кыргызча', flag: '🇰🇬' },
  };

  return (
    <Box>
      <IconButton
        color="inherit"
        onClick={handleClick}
        sx={{ ml: 1, minWidth: 44, minHeight: 44 }}
        aria-label={t('common.changeLanguage')}
      >
        <LanguageIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {Object.entries(languages).map(([key, { label, flag }]) => (
          <MenuItem
            key={key}
            onClick={() => handleLanguageChange(key)}
            selected={locale === key}
            sx={{ minWidth: 150 }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <span style={{ fontSize: '1.2em' }}>{flag}</span>
              <Typography>{label}</Typography>
            </Box>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default LanguageSwitcher;
